var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        { staticClass: "tabsClass" },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "基本数据" } },
            [
              _c("tabOneSum", { attrs: { fissionId: _vm.fissionId } }),
              _c("tabOneList", { attrs: { fissionId: _vm.fissionId } }),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "员工数据" } },
            [_c("tabTwoList", { attrs: { fissionId: _vm.fissionId } })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "客户数据" } },
            [_c("tabThreeList", { attrs: { fissionId: _vm.fissionId } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }